import { GetRequest } from '../../../../helpers/lopay_api_helper'
import { PaginatedVideoRequestResponseDto } from '../dtos/video-requests.dto'

export function getMerchantVideoRequests(merchantId: string) {
  return GetRequest<PaginatedVideoRequestResponseDto>(
    `support/merchant/${merchantId}/video-requests`,
  )
}
